// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 감시조건관리 화면 - 공통 스타일은 PageLayout.css 참조 */

.quiet-hours-box {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  background: white;
  border: 1px solid #e0e4ef;
  border-radius: 6px;
  padding: 10px 14px;
  margin-bottom: 12px;
  font-size: 12px;
}

.quiet-hours-toggle {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #444;
  font-weight: 600;
}

.quiet-hours-box input[type="time"] {
  padding: 4px 6px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 12px;
  font-family: inherit;
}

.watch-body {
  display: flex;
  gap: 16px;
  flex: 1 1;
  min-height: 0;
  overflow: hidden;
}

.watch-list-panel {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.col-desc {
  max-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #555;
}

.watch-form-panel {
  width: 320px;
  flex-shrink: 0;
  background: white;
  border: 1px solid #e0e4ef;
  border-radius: 6px;
  padding: 16px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.08);
  overflow-y: auto;
}

.form-title {
  font-size: 12px;
  font-weight: 700;
  color: #1a1a2e;
  margin: 0 0 16px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 12px;
}

.form-row {
  display: flex;
  gap: 8px;
}
.form-row .form-group { flex: 1 1; }

.form-group label {
  font-size: 12px;
  font-weight: 600;
  color: #444;
}

.form-group-checkbox label {
  display: flex;
  align-items: center;
  gap: 4px;
}

.required { color: #e74c3c; }

.form-group input[type="text"],
.form-group input[type="number"],
.form-group select {
  padding: 6px 9px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 12px;
  font-family: inherit;
  transition: border-color 0.2s;
}

.form-group input:focus,
.form-group select:focus {
  outline: none;
  border-color: #4a90e2;
}

.form-actions {
  display: flex;
  gap: 8px;
  margin-top: 16px;
}

/* ── 칩 입력 ── */
.chip-input-box {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  padding: 5px 7px;
  border: 1px solid #ddd;
  border-radius: 4px;
  min-height: 30px;
}

.chip-input-box:focus-within {
  border-color: #4a90e2;
}

.chip-input-box input {
  flex: 1 1;
  min-width: 80px;
  border: none;
  outline: none;
  font-size: 12px;
  font-family: inherit;
  padding: 2px;
}

.chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: #eef2fb;
  color: #2a4a8a;
  border-radius: 12px;
  padding: 2px 6px 2px 10px;
  font-size: 12px;
  white-space: nowrap;
}

.chip-remove {
  border: none;
  background: transparent;
  color: #7a8bb0;
  cursor: pointer;
  font-size: 13px;
  line-height: 1;
  padding: 0 2px;
}
.chip-remove:hover { color: #e74c3c; }
`, "",{"version":3,"sources":["webpack://./src/pages/marketplace/WatchConditionPage.css"],"names":[],"mappings":"AAAA,0CAA0C;;AAE1C;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,SAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;AACA,wBAAwB,SAAO,EAAE;;AAEjC;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,YAAY,cAAc,EAAE;;AAE5B;;;EAGE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;;EAEE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,SAAO;EACP,eAAe;EACf,YAAY;EACZ,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;EACd,cAAc;AAChB;AACA,qBAAqB,cAAc,EAAE","sourcesContent":["/* 감시조건관리 화면 - 공통 스타일은 PageLayout.css 참조 */\n\n.quiet-hours-box {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n  background: white;\n  border: 1px solid #e0e4ef;\n  border-radius: 6px;\n  padding: 10px 14px;\n  margin-bottom: 12px;\n  font-size: 12px;\n}\n\n.quiet-hours-toggle {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  color: #444;\n  font-weight: 600;\n}\n\n.quiet-hours-box input[type=\"time\"] {\n  padding: 4px 6px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 12px;\n  font-family: inherit;\n}\n\n.watch-body {\n  display: flex;\n  gap: 16px;\n  flex: 1;\n  min-height: 0;\n  overflow: hidden;\n}\n\n.watch-list-panel {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.col-desc {\n  max-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  color: #555;\n}\n\n.watch-form-panel {\n  width: 320px;\n  flex-shrink: 0;\n  background: white;\n  border: 1px solid #e0e4ef;\n  border-radius: 6px;\n  padding: 16px;\n  box-shadow: 0 1px 4px rgba(0,0,0,0.08);\n  overflow-y: auto;\n}\n\n.form-title {\n  font-size: 12px;\n  font-weight: 700;\n  color: #1a1a2e;\n  margin: 0 0 16px;\n  padding-bottom: 10px;\n  border-bottom: 1px solid #eee;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  margin-bottom: 12px;\n}\n\n.form-row {\n  display: flex;\n  gap: 8px;\n}\n.form-row .form-group { flex: 1; }\n\n.form-group label {\n  font-size: 12px;\n  font-weight: 600;\n  color: #444;\n}\n\n.form-group-checkbox label {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.required { color: #e74c3c; }\n\n.form-group input[type=\"text\"],\n.form-group input[type=\"number\"],\n.form-group select {\n  padding: 6px 9px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 12px;\n  font-family: inherit;\n  transition: border-color 0.2s;\n}\n\n.form-group input:focus,\n.form-group select:focus {\n  outline: none;\n  border-color: #4a90e2;\n}\n\n.form-actions {\n  display: flex;\n  gap: 8px;\n  margin-top: 16px;\n}\n\n/* ── 칩 입력 ── */\n.chip-input-box {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n  padding: 5px 7px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  min-height: 30px;\n}\n\n.chip-input-box:focus-within {\n  border-color: #4a90e2;\n}\n\n.chip-input-box input {\n  flex: 1;\n  min-width: 80px;\n  border: none;\n  outline: none;\n  font-size: 12px;\n  font-family: inherit;\n  padding: 2px;\n}\n\n.chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  background: #eef2fb;\n  color: #2a4a8a;\n  border-radius: 12px;\n  padding: 2px 6px 2px 10px;\n  font-size: 12px;\n  white-space: nowrap;\n}\n\n.chip-remove {\n  border: none;\n  background: transparent;\n  color: #7a8bb0;\n  cursor: pointer;\n  font-size: 13px;\n  line-height: 1;\n  padding: 0 2px;\n}\n.chip-remove:hover { color: #e74c3c; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
